import {
  type BusinessServiceConfig,
  Strategy,
  AbstractBusinessService,
} from '../core';
import { institutionOGService } from './rtkquery';
import type { Institution } from './institutions.types';

const strategyMap = {
  getInstitutionByDomain: Strategy.OG,
};

export type InstitutionsServiceInitConfig<StoreType> = Omit<
  BusinessServiceConfig<StoreType>,
  'serviceName' | 'strategyMap'
>;

export class InstitutionsService<StoreType> extends AbstractBusinessService<
  keyof typeof strategyMap,
  StoreType
> {
  constructor({ store, logger }: InstitutionsServiceInitConfig<StoreType>) {
    super({ serviceName: 'InstitutionsService', store, logger, strategyMap });
  }

  async fetchInstitutionByDomain(
    institutionDomain: string,
  ): Promise<Institution> {
    if (this.getStrategy('getInstitutionByDomain') === Strategy.OG) {
      const data = { institutionDomain };
      const response = await this.dispatchAction<Institution>(
        institutionOGService.endpoints.getInstitutionByDomain.initiate(data),
      );
      if ('data' in response) {
        return response.data;
      } else {
        throw response.error;
      }
    }
    throw new Error('Unsupported strategy');
  }
}
